<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'
import { required } from 'vuelidate/lib/validators'

import {
  ASSET_MUTATION_UPDATE,
  GET_MUTATION_ASSET,
} from '@/services/api/setting/personalization/uiAsset'
/**
 * Starter component
 */
export default {
  page: {
    title: 'Manajemen Whitelabel',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  mixins: [Helper],
  apollo: {
    uiAsset: {
      query: GET_MUTATION_ASSET,
      manual: true,
      fetchPolicy: 'no-cache',
      result({ data, loading }) {
        if (!loading) {
          const assetTypes = {
            companyName: 'companyName',
            headOffice: 'headOffice',
            headOfficePhone: 'headOfficePhone',
            headOfficeHandphone: 'headOfficeHandphone',
            operationalOffice: 'operationalOffice',
            operationalHandphone: 'operationalHandphone',
            facebookId: 'facebook',
            whatsappId: 'whatsapp',
            instagramId: 'instagram',
            linkedinId: 'linkedIn',
            youtubeId: 'youtube',
          }

          const assetTypesShow = {
            isShowFacebook: 'facebook',
            isShowWhatsapp: 'whatsapp',
            isShowInstagram: 'instagram',
            isShowLinkedin: 'linkedIn',
            isShowYoutube: 'youtube',
          }

          for (const [key, value] of Object.entries(assetTypes)) {
            this[key] = data.uiAssets.uiAssets.find(
              (o) => o.assetType === value && o.module === 'contactUs'
            ).value
          }

          for (const [key, value] of Object.entries(assetTypesShow)) {
            this[key] = data.uiAssets.uiAssets.find(
              (o) => o.assetType === value && o.module === 'contactUs'
            ).isActive
          }

          for (const [key, value] of Object.entries(this.assetsDefaultUrl)) {
            this[key] = this[key] != null ? this[key].replace(value, '') : null
          }
        }
      },
    },
  },
  data() {
    return {
      companyName: null,
      headOffice: null,
      headOfficePhone: null,
      headOfficeHandphone: null,
      operationalOffice: null,
      operationalHandphone: null,
      facebookId: null,
      isShowFacebook: true,
      instagramId: null,
      isShowInstagram: true,
      linkedinId: null,
      isShowLinkedin: true,
      youtubeId: null,
      isShowYoutube: true,
      whatsappId: null,
      isShowWhatsapp: true,
      assetsDefaultUrl: {
        facebookId: 'https://www.facebook.com/',
        whatsappId: 'https://wa.me/',
        instagramId: 'https://www.instagram.com/',
        linkedinId: 'https://www.linkedin.com/company/',
        youtubeId: 'https://www.youtube.com/',
      },
      isRequiredFacebook: false,
      isRequiredInstagram: false,
      isRequiredLinkedIn: false,
      isRequiredYoutube: false,
      isRequiredWhatsapp: false,
    }
  },

  validations: {
    facebookId: { required },
    instagramId: { required },
    linkedinId: { required },
    youtubeId: { required },
    whatsappId: { required },
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    title() {
      return this.$t('setting.list.managementAsset.companyContact.title')
    },
    items() {
      return [
        {
          text: this.$t('setting.homePage.pengaturan'),
          to: { name: 'Setting' },
        },
        {
          text: this.$t('setting.homePage.whitelabel'),
          to: { name: 'Management Whitelabel' },
        },
        {
          text: this.$t('setting.list.managementAsset.companyContact.title'),
          active: true,
        },
      ]
    },
  },

  methods: {
    toSave() {
      this.isRequiredFacebook = false
      this.isRequiredInstagram = false
      this.isRequiredLinkedIn = false
      this.isRequiredYoutube = false
      this.isRequiredWhatsapp = false
      let isValid = true
      if (this.isShowFacebook && (this.facebookId == '' || !this.facebookId)) {
        this.isRequiredFacebook = true
        isValid = false
      }
      if (this.isShowInstagram && (this.instagramId == '' || !this.instagramId)) {
        this.isRequiredInstagram = true
        isValid = false
      }
      if (this.isShowLinkedin && (this.linkedinId == '' || !this.linkedinId)) {
        this.isRequiredLinkedIn = true
        isValid = false
      }
      if (this.isShowYoutube && (this.youtubeId == '' || !this.youtubeId)) {
        this.isRequiredYoutube = true
        isValid = false
      }
      if (this.isShowWhatsapp && (this.whatsappId == '' || !this.whatsappId)) {
        this.isRequiredWhatsapp = true
        isValid = false
      }

      if (!isValid) {
        return
      }

      const input = [
        {
          assetType: 'companyName',
          module: 'contactUs',
          data: {
            value: this.companyName,
            isActive: true,
            isPhoto: false,
            photoExt: null,
          },
        },
        {
          assetType: 'headOffice',
          module: 'contactUs',
          data: {
            value: this.headOffice,
            isActive: true,
            isPhoto: false,
            photoExt: null,
          },
        },
        {
          assetType: 'headOfficePhone',
          module: 'contactUs',
          data: {
            value: this.headOfficePhone,
            isActive: true,
            isPhoto: false,
            photoExt: null,
          },
        },
        {
          assetType: 'headOfficeHandphone',
          module: 'contactUs',
          data: {
            value: this.headOfficeHandphone,
            isActive: true,
            isPhoto: false,
            photoExt: null,
          },
        },
        {
          assetType: 'operationalOffice',
          module: 'contactUs',
          data: {
            value: this.operationalOffice,
            isActive: true,
            isPhoto: false,
            photoExt: null,
          },
        },
        {
          assetType: 'operationalHandphone',
          module: 'contactUs',
          data: {
            value: this.operationalHandphone,
            isActive: true,
            isPhoto: false,
            photoExt: null,
          },
        },
        {
          assetType: 'facebook',
          module: 'contactUs',
          data: {
            value: this.generateAssetUrl('facebookId'),
            isActive: this.isShowFacebook,
            isPhoto: false,
            photoExt: null,
          },
        },
        {
          assetType: 'whatsapp',
          module: 'contactUs',
          data: {
            value: this.generateAssetUrl('whatsappId'),
            isActive: this.isShowWhatsapp,
            isPhoto: false,
            photoExt: null,
          },
        },
        {
          assetType: 'instagram',
          module: 'contactUs',
          data: {
            value: this.generateAssetUrl('instagramId'),
            isActive: this.isShowInstagram,
            isPhoto: false,
            photoExt: null,
          },
        },
        {
          assetType: 'linkedIn',
          module: 'contactUs',
          data: {
            value: this.generateAssetUrl('linkedinId'),
            isActive: this.isShowLinkedin,
            isPhoto: false,
            photoExt: null,
          },
        },
        {
          assetType: 'youtube',
          module: 'contactUs',
          data: {
            value: this.generateAssetUrl('youtubeId'),
            isActive: this.isShowYoutube,
            isPhoto: false,
            photoExt: null,
          },
        },
      ]
      this.$apollo
        .mutate({
          mutation: ASSET_MUTATION_UPDATE,
          variables: {
            input: input,
          },
        })
        .then((response) => {
          if (response.data.updateUIAssets.message != 'Successful') {
            return this.$mcToast.error(this.$t('global.alert.text.failSave'))
          }
          return this.$mcToast.success(this.$t('global.alert.text.saved'))
        })
    },

    generateAssetUrl(key) {
      return this[key] ? this.assetsDefaultUrl[key] + this[key] : null
    },
    onSwitchSocialMedia() {
      if (!this.isShowFacebook) {
        this.isRequiredFacebook = false
      }
      if (!this.isShowInstagram) {
        this.isRequiredInstagram = false
      }
      if (!this.isShowLinkedin) {
        this.isRequiredLinkedIn = false
      }
      if (!this.isShowYoutube) {
        this.isRequiredYoutube = false
      }
      if (!this.isShowWhatsapp) {
        this.isRequiredWhatsapp = false
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />
      <p class="mb-4">
{{ $t('setting.list.managementAsset.companyContact.subtitle') }}
</p>
      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button
            variant="outline-primary"
            class="ms-3"
            @click="$router.push({ name: 'Management Whitelabel' })"
          >
            <i class="mc-fa icon-outline_arrow-left"></i>
            {{ $t('global.back') }}
          </b-button>
          <b-button variant="btn btn-primary" class="ms-3" @click="toSave()">
            <i class="mc-fa icon-fill_checkmark"></i>
            {{ $t('global.apply') }}
          </b-button>
        </div>
      </div>
    </div>

    <div class="mc-form">
      <b-card class="card-title-box">
        <b-row>
          <b-col md="6">
            <h4 class="card-title mb-0">
              {{ $t('setting.list.managementAsset.companyContact.headOffice') }}
            </h4>
          </b-col>
        </b-row>
      </b-card>
      <b-card>
        <b-row>
          <b-col sm="12" md="6">
            <b-row class="mt-3">
              <b-col md="6">
                <h6>{{ $t('setting.list.managementAsset.companyContact.companyName') }}</h6>
                <b-form-group>
                  <b-form-input v-model="companyName" class="form-control" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col md="12">
                <h6>{{ $t('setting.list.managementAsset.companyContact.address') }}</h6>
                <b-form-group>
                  <b-form-textarea
                    v-model="headOffice"
                    rows="3"
                    class="form-control"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col md="6">
                <h6>{{ $t('setting.list.managementAsset.companyContact.phoneNumber') }}</h6>
                <b-form-group>
                  <b-form-input v-model="headOfficePhone" class="form-control" />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <h6>{{ $t('setting.list.managementAsset.companyContact.handphoneNumber') }}</h6>
                <b-form-group>
                  <b-input-group prepend="+62">
                    <b-form-input v-model="headOfficeHandphone" class="form-control" />
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
    </div>

    <div class="mc-form">
      <b-card class="card-title-box">
        <b-row>
          <b-col md="6">
            <h4 class="card-title mb-0">
              {{ $t('setting.list.managementAsset.companyContact.operationalOffice') }}
            </h4>
          </b-col>
        </b-row>
      </b-card>
      <b-card>
        <b-col md="6">
          <b-row>
            <b-col md="12">
              <h6>{{ $t('setting.list.managementAsset.companyContact.address') }}</h6>
              <b-form-group>
                <b-form-textarea
                  v-model="operationalOffice"
                  rows="3"
                  class="form-control"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col md="6">
              <h6>{{ $t('setting.list.managementAsset.companyContact.handphoneNumber') }}</h6>
              <b-form-group>
                <b-input-group prepend="+62">
                  <b-form-input v-model="operationalHandphone" class="form-control" />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-card>
    </div>

    <div class="mc-form">
      <b-card class="card-title-box">
        <b-row>
          <b-col md="6">
            <h4 class="card-title mb-0">
              {{ $t('setting.list.managementAsset.companyContact.socialMedia') }}
            </h4>
          </b-col>
        </b-row>
      </b-card>
      <b-card>
        <b-col md="6">
          <div>
            <b-row>
              <b-col md="6">
                <div class="d-flex justify-content-between">
                  <h6>
                    <span class="me-2"><img
src="@/assets/images/sosmed/fb.svg"
alt
height="20"
/></span>
                    Facebook
                  </h6>
                  <div>
                    <span>
                      <div class="form-check-right form-switch">
                        <input
                          v-model="isShowFacebook"
                          class="form-check-input"
                          type="checkbox"
                          @change="onSwitchSocialMedia"
                        />
                      </div>
                    </span>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <b-input-group prepend="@">
                    <b-form-input
                      v-model="facebookId"
                      class="form-control"
                      :class="{
                        'is-invalid': isRequiredFacebook,
                      }"
                    />

                    <div v-if="isRequiredFacebook" class="invalid-feedback">
                      <span v-if="!$v.facebookId.required">
                        Facebook
                        {{ $t('global.validation.required') }}
                      </span>
                    </div>
                  </b-input-group>
                  <div
                    v-if="isShowFacebook && !isRequiredFacebook"
                    class="custom-input-help-text input-md"
                  >
                    <label class="custom-required-help-text">
                      <span>* </span>{{ $t('global.validation.required') }}
                    </label>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <div class="mt-3">
            <b-row>
              <b-col md="6">
                <div class="d-flex justify-content-between">
                  <div>
                    <h6>
                      <span class="me-2"><img
src="@/assets/images/sosmed/ig.svg"
alt
height="20"
/></span>
                      Instagram
                    </h6>
                  </div>
                  <div>
                    <span>
                      <div class="form-check-right form-switch">
                        <input
                          v-model="isShowInstagram"
                          class="form-check-input"
                          type="checkbox"
                          @change="onSwitchSocialMedia"
                        />
                      </div>
                    </span>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <b-input-group prepend="@">
                    <b-form-input
                      v-model="instagramId"
                      class="form-control"
                      :class="{
                        'is-invalid': isRequiredInstagram,
                      }"
                    />

                    <div v-if="isRequiredInstagram" class="invalid-feedback">
                      <span v-if="!$v.instagramId.required">
                        Instagram
                        {{ $t('global.validation.required') }}
                      </span>
                    </div>
                  </b-input-group>
                  <div
                    v-if="isShowInstagram && !isRequiredInstagram"
                    class="custom-input-help-text input-md"
                  >
                    <label class="custom-required-help-text">
                      <span>* </span>{{ $t('global.validation.required') }}
                    </label>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <div class="mt-3">
            <b-row>
              <b-col md="6">
                <div class="d-flex justify-content-between">
                  <h6>
                    <span class="me-2"><img
src="@/assets/images/sosmed/ln.svg"
alt
height="20"
/></span>
                    LinkedIn
                  </h6>
                  <div>
                    <span>
                      <div class="form-check-right form-switch">
                        <input
                          v-model="isShowLinkedin"
                          class="form-check-input"
                          type="checkbox"
                          @change="onSwitchSocialMedia"
                        />
                      </div>
                    </span>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <b-input-group prepend="@">
                    <b-form-input
                      v-model="linkedinId"
                      class="form-control"
                      :class="{
                        'is-invalid': isRequiredLinkedIn,
                      }"
                    />

                    <div v-if="isRequiredLinkedIn" class="invalid-feedback">
                      <span v-if="!$v.linkedinId.required">
                        linkedIn
                        {{ $t('global.validation.required') }}
                      </span>
                    </div>
                  </b-input-group>
                  <div
                    v-if="isShowLinkedin && !isRequiredLinkedIn"
                    class="custom-input-help-text input-md"
                  >
                    <label class="custom-required-help-text">
                      <span>* </span>{{ $t('global.validation.required') }}
                    </label>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <div class="mt-3">
            <b-row>
              <b-col md="6">
                <div class="d-flex justify-content-between">
                  <h6>
                    <span class="me-2"><img
src="@/assets/images/sosmed/yt.svg"
alt
height="20"
/></span>
                    Youtube
                  </h6>
                  <div>
                    <span>
                      <div class="form-check-right form-switch">
                        <input
                          v-model="isShowYoutube"
                          class="form-check-input"
                          type="checkbox"
                          @change="onSwitchSocialMedia"
                        />
                      </div>
                    </span>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <b-input-group prepend="@">
                    <b-form-input
                      v-model="youtubeId"
                      class="form-control"
                      :class="{
                        'is-invalid': isRequiredYoutube,
                      }"
                    />

                    <div v-if="isRequiredYoutube" class="invalid-feedback">
                      <span v-if="!$v.youtubeId.required">
                        Youtube
                        {{ $t('global.validation.required') }}
                      </span>
                    </div>
                  </b-input-group>
                  <div
                    v-if="isShowYoutube && !isRequiredYoutube"
                    class="custom-input-help-text input-md"
                  >
                    <label class="custom-required-help-text">
                      <span>* </span>{{ $t('global.validation.required') }}
                    </label>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <div class="mt-3">
            <b-row>
              <b-col md="6">
                <div class="d-flex justify-content-between">
                  <h6>
                    <span class="me-2"><img
src="@/assets/images/sosmed/wa.svg"
alt
height="20"
/></span>
                    Whatsapp
                  </h6>
                  <div>
                    <span>
                      <div class="form-check-right form-switch">
                        <input
                          v-model="isShowWhatsapp"
                          class="form-check-input"
                          type="checkbox"
                          @change="onSwitchSocialMedia"
                        />
                      </div>
                    </span>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <b-input-group prepend="+62">
                    <b-form-input
                      v-model="whatsappId"
                      class="form-control"
                      :class="{
                        'is-invalid': isRequiredWhatsapp,
                      }"
                    />

                    <div v-if="isRequiredWhatsapp" class="invalid-feedback">
                      <span v-if="!$v.whatsappId.required">
                        Whatsapp
                        {{ $t('global.validation.required') }}
                      </span>
                    </div>
                  </b-input-group>
                  <div
                    v-if="isShowWhatsapp && !isRequiredWhatsapp"
                    class="custom-input-help-text input-md"
                  >
                    <label class="custom-required-help-text">
                      <span>* </span>{{ $t('global.validation.required') }}
                    </label>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-card>
    </div>
  </Layout>
</template>
